import GraphinaGoogleChartBase from './GraphinaGoogleChartBase';

// Child class specifically for Gauge Charts
export default class GaugeChart extends GraphinaGoogleChartBase {
    constructor(settings) {
        super(settings);
        this.chart = null;
        this.data = null;
        this.options = {};
        window.addEventListener('resize', this.debounce(() => {
            jQuery('.graphina-google-chart[data-chart_type="gauge_google"]').each((index, element) => {
                this.setupChart(jQuery(element), 'Gauge');
            });
        }, 250));
    }

    /**
     * Sets up the chart handlers for Google Gauge Chart.
     */
    setUpChartsHandler() {
        this.chartHandlers = {
            gauge_google: (element) => this.observeChartElement(element, 'Gauge'),
        };

    }

    /**
     * Observes the chart element and initializes it when in viewport.
     * @param {jQuery} element - The jQuery element reference.
     * @param {string} chartType - The type of chart to initialize.
     */
    observeChartElement(element, chartType) {
        if (gcfe_public_localize.view_port === 'off') {
            if (!this.observer) {
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            // Initialize chart when in viewport
                            this.setupChart(jQuery(entry.target), chartType);
                            this.observer.unobserve(entry.target);
                        }
                    });
                }, { threshold: 0.1 });
            }
            this.observer.observe(element[0]);
        } else {
            this.setupChart(element, chartType);
        }
    }


    // Customize chart options for Gantt Charts (if needed)
    getFinalChartOptions(chartOptions,elementId){
        const width = window.innerWidth;
        let finalOptions = { ...chartOptions };

        if (width <= 767) { // Mobile
            if (chartOptions.width_mobile) finalOptions.width = chartOptions.width_mobile;
            if (chartOptions.height_mobile) finalOptions.height = chartOptions.height_mobile;
        } else if (width <= 1024) { // Tablet
            if (chartOptions.width_tablet) finalOptions.width = chartOptions.width_tablet;
            if (chartOptions.height_tablet) finalOptions.height = chartOptions.height_tablet;
        }

        return finalOptions;
    }

    setupTableData(dynamicData, dataTable, googleChart, googleChartTexture, extraData) {
        if(dynamicData?.google_chart_data?.data.length > 0){
            dataTable.addColumn('string', 'Label');
            dataTable.addColumn('number', 'Value');
            dynamicData.google_chart_data.data.forEach(row => dataTable.addRow(row));
            googleChart.show()
            googleChartTexture.hide()
        } else if(dynamicData?.columns.length > 0 && dynamicData.rows.length > 0){
            dynamicData.columns.forEach((col, index) => {
                dataTable.addColumn(col[0],col[1])
            });
            dynamicData.rows.forEach(row => dataTable.addRow(row));
        } else{
            googleChart.hide()
            googleChartTexture.show()
        }
        this.applyLocaleFormatting(dataTable, extraData);
    }
    
    afterSetupChart(element, extraData,chart,dataTable,finalChartOptions) {
        // Define color mappings
        const circleColors = {
            "#4684ee": extraData.ballColor ?? "#4684ee",
            "#f7f7f7": extraData.innerCircleColor ?? "#f7f7f7",
            "#cccccc": extraData.outerCircleColor ?? "#cccccc"
        };
    
        const needleColor = extraData.needleColor ?? "#c63310";
    
        // Update circle colors
        element.querySelectorAll("circle").forEach(circle => {
            const fillColor = circleColors[circle.getAttribute("fill")];
            if (fillColor) circle.setAttribute("fill", fillColor);
        });
    
        // Update path colors
        element.querySelectorAll("path").forEach(path => {
            if (path.getAttribute("stroke") === "#c63310") {
                path.setAttribute("stroke", needleColor);
                path.setAttribute("fill", needleColor);
            }
        });
    }
    


}
// Initialize Gauge Chart
window.graphinaGoogleGaugeChart = new GaugeChart();
